module.exports = __webpack_public_path__ + "static/scale-model-of-friendship-archway-in-washington-d.c.-f80df6a9310ea9f27ffc1cabf8bf9e5c.png";